module.exports = __webpack_public_path__ + "5ad6503d34ee6941281f3ab5c3ba8774.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/stomach/stomach-28.png
// module id = 2469
// module chunks = 0